import * as API from '../../API/configAPI';
import * as actions from './index';
import { AuthActionTypes } from './actionTypes';

export const uploadPhoto = (extension, arrayBuffer) => {
   return (dispatch) => {
      dispatch({
         type: AuthActionTypes.UPLOAD_PHOTO,
         payload: API.getPresignedUrl(extension)
            .then((response) => {
               if (response.data.success || response.data.success === 'true') {
                  if (response.data.urls && response.data.urls.length > 0) {
                     response.data.urls.map((url, index) => {
                        dispatch(
                           uploadPhotoToS3(url.presigned_url, arrayBuffer)
                        );
                     });
                  }

                  return { ...response.data };
               }
            })
            .catch((error) => {
               console.log(error);
               return { ...error };
            }),
      });
   };
};

export const uploadPhotoToS3 = (url, baseImage) => (dispatch) =>
   dispatch({
      type: AuthActionTypes.UPLOAD_PHOTO_TO_S3_BUCKET,
      payload: API.uploadImageToS3(url, baseImage)
         .then((response) => {
            return response.data;
         })
         .catch((error) => {
            return error;
         }),
   });
